export const data = [
  {
    designation: "Senior Software Engineer - PERN",
    duration: "08/2023 - present",
    company: "Digistore Pay - Kottayam, India",
    description:
      "At Digistore Pay, a payments aggregator startup, I worked for more than 1 year. My responsibilities included architecting and revamping their core business website and app. I gained immense experience working with dockerization and azure cloud services.",
  },
  {
    designation: "Full-Stack Developer - Freelance",
    duration: "11/2022 - 08/2023",
    company: "Skillojo, RhinoPay, MasterFraming - Australia",
    description:
      "As a remote freelance developer, I have worked with clients like Skillojo, MasterFraming, and Rhinopay. Skillojo is an AI-powered employment portal, while MasterFraming specializes in online framing services and Rhinopay is a payments platform. My services for these clients included design, development, bug fixing, building authentication systems, and testing. I have been freelancing for over 6 months, gaining valuable experience and expertise.",
  },
  {
    designation: "Software Engineer - Systems",
    duration: "11/2021 - 10/2022",
    company: "Travancore Analytics - Kochi, India",
    description:
      "At Travancore Analytics, a custom software development company, I worked as Software Engineer - Systems for close to a year. I collaborated with their clients such as Capital One, developing custom solutions using React and Node.js. My responsibilities mainly included writing test cases with Jest and optimizing backend logic in Node.js.",
  },
  {
    designation: "Full-Stack Developer",
    duration: "06/2021 - 11/2021",
    company: "DigiSuvidha Pvt Ltd - Kottayam, India",
    description:
      "At Digisuvidha, a service aggregation startup, I worked for 5 months. My responsibilities included revamping the business website and developing a new service to recharge mobile phones through their payments app. I gained experience integrating testing and logging APIs from various telephone operators in a production environment.",
  },
  {
    designation: "Full-Stack Developer - React/Node",
    duration: "06/2019 - 02/2021",
    company: "Phyction Ai Labs - Kochi, India",
    description:
      "At Phyction Ai Labs, a startup, I served as a Full Stack Developer for nearly two years, specializing in the MERN stack. My primary responsibilities included building internal tools such as CMS systems and dashboards. Additionally, I occasionally took on website development projects for clients and focused on optimizing website performance.",
  },
  {
    designation: "Angular Developer - Freelance",
    duration: "04/2019 - 08/2019",
    company: "Medclick - Australia",
    description:
      "At Medclick, a medical startup utilizing blockchain technology, I worked remotely as an Angular Developer. I collaborated with the UI/UX design team to convert their concepts into a functional website. This involved a two-month development period, followed by an additional two months of AWS deployment and website maintenance. My role encompassed translating designs using Angular, and ensuring optimal performance.",
  },
];
